// @ts-nocheck
import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { CprRegex, PhoneRegex } from '../../shared/regex';

export function getSchema(t: TFunction) {
  return Yup.object().shape({
    cpr: Yup.string().required(t('form-input-cpr-error')).matches(CprRegex, t('form-input-cpr-error')),
    name: Yup.string().required(t('form-input-name-error')),
    phone: Yup.string()
      .required(t('form-input-phone-error'))
      .matches(PhoneRegex, t('form-input-phone-error'))
      .min(8, t('form-input-phone-error')),
    email: Yup.string().required(t('form-input-email-error')).email(t('form-input-email-error')),
  });
}
